module.exports = __webpack_public_path__ + "img/p2-bg.453a46e5.webp";